import RevealUsageOverview from 'features/reveal/components/RevealUsageOverview'
import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

export default [routeWithLayout({ main: RevealUsageOverview, path: UrlProvider.getRawUrl('reveal') })]
